import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b9f76e2a")

_pushScopeId("data-v-b9f76e2a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("New to WeTrade")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Complete the starting guide and earn points")
const _hoisted_3 = { style: {"overflow":"hidden"} }
const _hoisted_4 = { class: "fill df-col df-center" }
const _hoisted_5 = { class: "df-middle" }
const _hoisted_6 = {
  key: 0,
  class: "df-middle px-12 mt-4"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Free Prime member and more")
const _hoisted_8 = { class: "state" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_Donut = _resolveComponent("Donut")
  const _component_Icon = _resolveComponent("Icon")
  const _component_RedPointAlert = _resolveComponent("RedPointAlert")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_t, {
      as: "p",
      path: "home_12",
      class: "f-xxl f-bold t-center"
    }, {
      default: _withId(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_t, {
      as: "p",
      path: "home_13",
      class: "mt-16"
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tasks, (item) => {
        return (_openBlock(), _createBlock(_component_RedPointAlert, {
          id: 'rt_' + item.tag,
          key: item.tag,
          class: [{'bg-white': _ctx.isCurrentTask(item.tag)}, "task df-middle br-lg"],
          display: _ctx.isCurrentTask(item.tag),
          tag: "div",
          onClick: ($event: any) => (_ctx.perform(_ctx.isCurrentTask(item.tag) ? item : null))
        }, {
          default: _withId(() => [
            _createVNode(_component_Pic, {
              src: item.icon,
              fallback: "/img/home/flag@2x.png",
              width: "32",
              height: "32"
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("p", {
                  class: ["flex-1 t-left px-12 c-text", {'c-title': !_ctx.isCurrentTask(item.tag), 'c-tip': item.status === _ctx.DONE}]
                }, _toDisplayString(item.title), 3),
                (item.award)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: ["f-bold c-title", {'c-tip': item.status === _ctx.DONE, 'c-success': _ctx.isCurrentTask(item.tag)}]
                    }, "+" + _toDisplayString(item.award || 0) + " pts", 3))
                  : _createCommentVNode("", true)
              ]),
              (item.tag === _ctx.TaskType.DEPOSIT$50)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode(_component_Pic, {
                      src: "home/gift",
                      width: "16",
                      height: "16"
                    }),
                    _createVNode(_component_t, {
                      path: "home_57",
                      class: "f-md ml-4",
                      style: {"color":"#F07B00"}
                    }, {
                      default: _withId(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_8, [
              (_ctx.isCurrentTask(item.tag) && _ctx.loading)
                ? (_openBlock(), _createBlock(_component_Donut, {
                    key: 0,
                    sm: ""
                  }))
                : (_ctx.isCurrentTask(item.tag))
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 1,
                      name: "caret-right",
                      class: "c-title",
                      sm: ""
                    }))
                  : (item.status === _ctx.DONE)
                    ? (_openBlock(), _createBlock(_component_Icon, {
                        key: 2,
                        name: "check",
                        class: "c-title",
                        sm: ""
                      }))
                    : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1032, ["id", "class", "display", "onClick"]))
      }), 128))
    ])
  ], 64))
})